import React, { useState, ReactNode } from 'react';
import classNames from 'classnames';
import './PreviewBox.pcss';

type ChildrenProps = {
  isMobile: boolean;
};

type Props = {
  className?: string;
  children: (props: ChildrenProps) => ReactNode;
};

export const PreviewBox = ({ className, children }: Props) => {
  const [isMobile, setIsMobile] = useState(false);

  return (
    <div className={classNames(className, 'preview-box')}>
      <div className="preview-box__title">Preview</div>
      <div className="preview-box__device-switch">
        <span
          className={classNames('preview-box__switch-item', {
            'preview-box__switch-item--active': !isMobile,
          })}
          onClick={() => setIsMobile(false)}
        >
          Desktop
        </span>
        <span
          className={classNames('preview-box__switch-item', {
            'preview-box__switch-item--active': isMobile,
          })}
          onClick={() => setIsMobile(true)}
        >
          Mobile
        </span>
      </div>

      <div className="preview-box__preview-render">
        {children({ isMobile })}
      </div>
    </div>
  );
};
